export enum APPLE_PAY_FIELD {
    GIVEN_NAME = 'givenName',
    FAMILY_NAME = 'familyName',
}
